import React from "react";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import "./RadioGroup.scss";
import { isMobile, isIpad } from "../../global/ScreenSizeHelper";

function RadioGroup(props) {
    const { handleChange, value, options, className = "atomic-radio-group" } = props;
    return (
        <span className={className}>
            <ToggleButtonGroup
                value={value}
                exclusive
                onChange={handleChange}
                aria-label="text alignment"
                sx={{}}
            >
                {options.map((option, i) => (
                    <ToggleButton
                        key={i}
                        value={option.value}
                        aria-label="left aligned"
                        color="info"
                        size="large"
                    >
                        {option.label}
                    </ToggleButton>
                ))}
            </ToggleButtonGroup>
        </span>
    );
}
export default RadioGroup;
RadioGroup.defaultProps = {
    handleChange: null,
    screenSize: "large",
    value: "",
    options: [],
};
